/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import IconPushSplashDefault from './push-splash-icon.svg';
import IconWishlist from './push-wishlist-icon.svg';
import IconSelling from './push-selling-icon.svg';
import * as pushNotificationActions from 'tradera/state/push-notifications/push-notifications-slice';
import { GtmService } from 'tradera/services/google-tagmanager-service';
import { useDispatch } from 'react-redux';
import { useTranslator } from 'tradera/lang/translate';
import CheckIcon from '@tradera/blueprint/theme/icons2/check.svg?jsx';
import { Button } from '../atoms/button/button';
import { ScrollableModal } from '../scrollable-modal/scrollable-modal';
import { Space } from '../atoms/space/space';

const PushNotificationModal = ({
    modalType,
    gaLabel,
    title,
    description,
    tagGroups,
    closeModal
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslator();

    const trackGa = (gaLabel) => {
        GtmService.trackAction('Settings', 'Notifications', gaLabel);
    };

    const handleAccept = async () => {
        trackGa(gaLabel);
        closeModal();
        try {
            dispatch(pushNotificationActions.addTagGroups(tagGroups));
            dispatch(pushNotificationActions.setShownModalTrue(modalType));
        } catch (error) {
            // error, do not do anything
        }
    };

    const handleReject = async () => {
        closeModal();
        trackGa('Decline - Opt-in alert');
        dispatch(pushNotificationActions.setShownModalTrue(modalType));
    };

    let icon = IconPushSplashDefault;

    if (modalType === 'wishlistReminders') {
        icon = IconWishlist;
    } else if (modalType === 'selling') {
        icon = IconSelling;
    }

    return (
        <ScrollableModal
            show
            maxWidth="23rem"
            onClose={closeModal}
            footer={
                <Space direction="vertical">
                    <Button
                        theme="primary"
                        variant="outline"
                        fluid
                        onClick={handleReject}>
                        {t('pushModal_btn_no')}
                    </Button>
                    <Button theme="primary" fluid onClick={handleAccept}>
                        <CheckIcon className="icon icon-white" />{' '}
                        {t('pushModal_btn_yes')}
                    </Button>
                </Space>
            }>
            <div className="text-center p-4">
                <img src={icon} className="mt-4 mb-5" alt="" />
                <h3 className="pb-4 text-styled">{t(title)}</h3>
                <p
                    className="pb-5"
                    dangerouslySetInnerHTML={{ __html: t(description) }}
                />
            </div>
        </ScrollableModal>
    );
};

PushNotificationModal.propTypes = {
    modalType: PropTypes.string.isRequired,
    gaLabel: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    tagGroups: PropTypes.array.isRequired,
    closeModal: PropTypes.func.isRequired
};

export default PushNotificationModal;
